import React, { useState } from "react";
import AartiThali from "../../components/idol/idolAnimation/AartiThali";
import FlowerRain from "../../components/idol/idolAnimation/FlowerRain";
import Bell from "../../components/idol/idolAnimation/Bell";
import { FaBell, FaSpa, FaGem, FaPrayingHands } from "react-icons/fa";
import { motion } from "framer-motion"; // Import Framer Motion for animation
import GemsRain from "../../components/idol/idolAnimation/GemsRain";
import GoldDustSwirls from "../../components/idol/idolAnimation/GoldDustSwirls";
import GoldSwirlEffect from "../../components/idol/idolAnimation/GoldSwirlEffect";
import FairyGlitterTrail from "../../components/idol/idolAnimation/FairyGlitterTrail";
import GlitterHeartTrail from "../../components/idol/idolAnimation/GlitterHeartTrail";
import Wrapper from "../../views/common/commonWrapper";
import Nav from "../navbar";
import { Button } from "reactstrap";
import { useSelector } from "react-redux";
function Idol() {
  // const [isBellAnimating, setIsBellAnimating] = useState(false);
  const [isFlowerRain, setIsFlowerRain] = useState(false);
  const [isAarti, setIsAarti] = useState(false);
  const [isGems, setIsGems] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const trustId = localStorage.getItem("trustId");
  const userDetails = useSelector((state) => state.auth);
  const trustData = userDetails && userDetails?.trustData;
  const idols = trustData?.idols || [];
  const mainIdols = Array.isArray(idols)
    ? idols.filter((idol) => idol.isMain)
    : [];
  const [isBellAnimating, setIsBellAnimating] = useState(
    JSON.parse(localStorage.getItem("isBellAnimating")) || false
  );

  const toggleBell = () => {
    const newState = !isBellAnimating;
    setIsBellAnimating(newState);
    localStorage.setItem("isBellAnimating", JSON.stringify(newState));

    // Dispatch a custom event to notify other components
    window.dispatchEvent(new Event("bellAnimatingChanged"));
  };

  const toggleFlowerRain = () => {
    setIsFlowerRain((prev) => {
      const newState = !prev;
      if (newState) {
        setIsAarti(false);
        setIsGems(false);
      }
      return newState;
    });
  };

  const toggleAarti = () => {
    setIsAarti((prev) => {
      const newState = !prev;
      if (newState) {
        setIsFlowerRain(false);
        setIsGems(false);
      }
      return newState;
    });
  };

  const toggleGems = () => {
    setIsGems((prev) => {
      const newState = !prev;
      if (newState) {
        setIsAarti(false);
        setIsFlowerRain(false);
      }
      return newState;
    });
  };

  return (
    <>
      <Nav />
      <div className="main-layout hide-scrollbar" style={{ padding: "0px" }}>
        <div className="">
          <GlitterHeartTrail
            isAarti={isAarti}
            isFlowerRain={isFlowerRain}
            isGems={isGems}
            isBellAnimating={isBellAnimating}
            mainIdols={mainIdols}
          />
          {/* Floating Buttons Container */}
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              display: "flex",
              gap: "15px",
              zIndex: 10000,
            }}
          >
            {/* Bell Toggle Button */}
            <motion.button
              onClick={toggleBell}
              style={{
                ...buttonStyle,
                backgroundColor: isBellAnimating ? "#FFD700" : "#ff9800",
                boxShadow: isBellAnimating
                  ? "0px 0px 10px 5px rgba(255, 223, 0, 0.7)"
                  : "none",
              }}
              whileTap={{ scale: 0.9 }}
            >
              <FaBell size={24} />
            </motion.button>

            {/* Flower Rain Toggle Button */}
            <motion.button
              onClick={toggleFlowerRain}
              style={{
                ...buttonStyle,
                backgroundColor: isFlowerRain ? "#FF69B4" : "#ff9800",
                boxShadow: isFlowerRain
                  ? "0px 0px 10px 5px rgba(255, 105, 180, 0.7)"
                  : "none",
              }}
              whileTap={{ scale: 0.9 }}
            >
              <FaSpa size={24} />
            </motion.button>

            {/* Aarti Thali Toggle Button */}
            <motion.button
              onClick={toggleAarti}
              style={{
                ...buttonStyle,
                backgroundColor: isAarti ? "#32CD32" : "#ff9800",
                boxShadow: isAarti
                  ? "0px 0px 10px 5px rgba(50, 205, 50, 0.7)"
                  : "none",
              }}
              whileTap={{ scale: 0.9 }}
            >
              <FaPrayingHands size={24} />
            </motion.button>

            {/* Gems Rain Toggle Button */}
            <motion.button
              onClick={toggleGems}
              style={{
                ...buttonStyle,
                backgroundColor: isGems ? "#8e44ad" : "#ff9800",
                boxShadow: isGems
                  ? "0px 0px 10px 5px rgba(50, 91, 205, 0.7)"
                  : "none",
              }}
              whileTap={{ scale: 0.9 }}
            >
              <FaGem size={24} />
            </motion.button>
          </div>
        </div>
      </div>
    </>
  );
}

// Style for round floating buttons
const buttonStyle = {
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  color: "white",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
};

export default Idol;
